import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getBUYERSTableStructure";
export const UPDATE_TABLE_DATA = "getBUYERSTableData";
export const UPDATE_CREATE_DATA = "getBUYERSCreateData";
export const EXPORT_TABLE_DATA = "getBUYERSEXPORTTABLEDATA";

// mutation types
export const SET_TABLE_STRUCTURE = "setBUYERSTableStructure";
export const SET_TABLE_DATA = "setBUYERSTableData";
export const SET_TABLE_FILTER = "setBUYERSTableFilter";
export const SET_TABLE_PAGE = "setBUYERSTablePage";
export const SET_TABLE_PERPAGE = "setBUYERSTablePerPage";
export const SET_TABLE_SORTBY = "setBUYERSTableSortBy";
export const SET_TABLE_SORTORDER = "setBUYERSTableSortOrder";
export const SET_CREATE_DATA = "setBUYERSCreateData";
export const SET_EXPORT_LINK = "setBUYERSExportLink";

const state = {
  table_structure: {},
  table_data: {},
  create_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  export_link: null,
};

const getters = {
  getBUYERSTableState(state) {
    return state.table_state;
  },

  getBUYERSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getBUYERSTableFilters(state) {
    return state.table_structure.filters;
  },

  getBUYERSTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getBUYERSTableData(state) {
    return state.table_data.data;
  },

  getBUYERSStoresData(state) {
    return state.create_data.stores;
  },
  getBUYERSTableProperties(state) {
    return state.table_structure.properties;
  },
  getBUYERSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/buyers")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/buyers/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CREATE_DATA](context, payload) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/buyers/create", payload)
        .then(({ data }) => {
          context.commit(SET_CREATE_DATA, data);
          resolve(data);

          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/buyers/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_CREATE_DATA](state, create_data) {
    state.create_data = create_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
